import { QueryFilters, QueryFiltersDomainOnly } from '../types';

export const buildUniversalMfaQueryParams = (filters: QueryFilters) => {
    return {
        domain: filters.domain.join(','),
        timeframe: filters.timeframe
    };
};

export const buildUniversalMfaDomainQueryParams = (filters: QueryFiltersDomainOnly) => {
    return {
        domain: filters.domain.join(',')
    };
};
